import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';

import { SpinnerComponent } from './spinner.component';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  spinnerOverlayRefs: OverlayRef[] = [];

  constructor(private overlay: Overlay) {}

  addSpinner() {
    // Use CDK to attach spinner to page
    const overlayRef = this.overlay.create({});
    const spinnerComponent = new ComponentPortal(SpinnerComponent);
    overlayRef.attach(spinnerComponent);

    this.spinnerOverlayRefs.push(overlayRef);
  }

  removeSpinner() {
    const overlayRef = this.spinnerOverlayRefs.pop();

    if (overlayRef?.hasAttached()) {
      overlayRef.detach();
    }

    overlayRef?.dispose();
  }
}
